<template>
  <transition name="fade">
    <v-col cols="12" class="py-0">
      <component
        :is="componentSegment[currentDisplay]"
        :handleSelectOption="handleSelectOption"
        :handleBack="handleBackOptions"
        :liveVideoId="videoId"
        :customVideoId="videoId"
        :isExternalSourceVideo="isExternalSourceVideo"
      />
    </v-col>
  </transition>
</template>

<script>
import VideoPlayerOptions from './VideoPlayerOptions.vue'
import VideoPlayerSubtitles from './VideoPlayerSubtitles.vue'
import VideoPlayerSubtitlesV1 from './VideoPlayerSubtitlesV1.vue'
import VideoPlayerDubbing from './VideoPlayerDubbing.vue'
import VideoPlayerThumbnails from './VideoPlayerThumbnails.vue'
import VideoPlayerColors from './VideoPlayerColors.vue'
import VideoPlayerControls from './VideoPlayerControls.vue'
import VideoPlayerAutoplay from './VideoPlayerAutoplay.vue'
import VideoPlayerChapters from './VideoPlayerChapters.vue'
import VideoPlayerAlternativeProgress from './VideoPlayerAlternativeProgress.vue'
import VideoPlayerPreviewThumbs from './VideoPlayerPreviewThumbs.vue'
import VideoPlayerSaveProgress from './VideoPlayerSaveProgress.vue'
import VideoPlayerFacebookPixel from './VideoPlayerFacebookPixel.vue'
import VideoPlayerButtons from './VideoPlayerButtons.vue'
import VideoPlayerQuality from './VideoPlayerQuality.vue'
import VideoPlayerAffiliate from './VideoPlayerAffiliate.vue'
import VideoPlayerBigPlayButton from './VideoPlayerBigPlayButton.vue'
import VideoPlayerMiniTrigger from './VideoPlayerMiniTrigger.vue'
import VideoPlayerPixels from './VideoPlayerPixels.vue'
import VideoPlayerDRMSecurity from './VideoPlayerDRMSecurity.vue'
import VideoPlayerMindMap from './videoPlayerOptionsAI/VideoPlayerMindMap.vue'
import VideoPlayerQuiz from './videoPlayerOptionsAI/VideoPlayerQuiz.vue'
import VideoPlayerEbook from './videoPlayerOptionsAI/VideoPlayerEbook.vue'
import VideoPlayerSpeed from './VideoPlayerSpeed.vue'

export default {
  name: 'VideoPlayer',
  props: {
    videoId: {
      type: String,
    },
    isExternalSourceVideo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VideoPlayerAffiliate,
    VideoPlayerOptions,
    VideoPlayerSubtitlesV1,
    VideoPlayerSubtitles,
    VideoPlayerDubbing,
    VideoPlayerThumbnails,
    VideoPlayerColors,
    VideoPlayerBigPlayButton,
    VideoPlayerControls,
    VideoPlayerAutoplay,
    VideoPlayerChapters,
    VideoPlayerAlternativeProgress,
    VideoPlayerPreviewThumbs,
    VideoPlayerSaveProgress,
    VideoPlayerFacebookPixel,
    VideoPlayerQuality,
    VideoPlayerButtons,
    VideoPlayerMiniTrigger,
    VideoPlayerPixels,
    VideoPlayerDRMSecurity,
    VideoPlayerMindMap,
    VideoPlayerQuiz,
    VideoPlayerEbook,
    VideoPlayerSpeed,
  },
  data: () => ({
    currentDisplay: 'options',
  }),
  computed: {
    componentSegment() {
      return {
        options: 'VideoPlayerOptions',
        minitrigger: 'VideoPlayerMiniTrigger',
        subtitlesV1: 'VideoPlayerSubtitlesV1',
        subtitles: 'VideoPlayerSubtitles',
        dubbing: 'VideoPlayerDubbing',
        thumbnails: 'VideoPlayerThumbnails',
        colors: 'VideoPlayerColors',
        controls: 'VideoPlayerControls',
        chapters: 'VideoPlayerChapters',
        autoplay: 'VideoPlayerAutoplay',
        alternativeProgress: 'VideoPlayerAlternativeProgress',
        showPreviewThumbs: 'VideoPlayerPreviewThumbs',
        saveProgress: 'VideoPlayerSaveProgress',
        facebookPixel: 'VideoPlayerFacebookPixel',
        affiliate: 'VideoPlayerAffiliate',
        buttons: 'VideoPlayerButtons',
        quality: 'VideoPlayerQuality',
        bigPlayButton: 'VideoPlayerBigPlayButton',
        pixels: 'VideoPlayerPixels',
        drmSecurity: 'VideoPlayerDRMSecurity',
        summary: 'VideoPlayerSummary',
        mindMap: 'VideoPlayerMindMap',
        quiz: 'VideoPlayerQuiz',
        ebook: 'VideoPlayerEbook',
        speed: 'VideoPlayerSpeed',
      }
    },
  },
  methods: {
    handleSelectOption(option) {
      this.currentDisplay = option
    },
    handleBackOptions() {
      this.handleSelectOption('options')
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
